import { call, put, takeLatest } from 'redux-saga/effects'
import * as types from '../../../actions/index.types'
import { toast } from 'react-toastify';
import * as req from '../../../../axios/request/SocietyPortal/InvestmentReqs/InvestmentReqs'

// Extract the user-facing message from an axios error or a {success:false} response.
const extractError = (e, fallback) =>
    e?.response?.data?.message ||
    e?.data?.message ||
    e?.message ||
    fallback;

function* getInvestments(action) {
    try {
        const result = yield call(req.getInvestmentsReq, action);
        if (result.success === true) {
            yield put({ type: types.GET_INVESTMENTS_SUCCESS, payload: result });
        } else {
            const msg = result?.message || "Failed to fetch investments";
            yield put({ type: types.GET_INVESTMENTS_FAILURE, message: msg });
            toast.error(msg);
        }
    } catch (e) {
        console.log(e)
        const msg = extractError(e, "Failed to fetch investments");
        yield put({ type: types.GET_INVESTMENTS_FAILURE, message: msg });
        toast.error(msg);
    }
}

function* getInvestmentDetails(action) {
    try {
        const result = yield call(req.getInvestmentDetailsReq, action);
        if (result.success === true) {
            yield put({ type: types.GET_INVESTMENT_DETAILS_SUCCESS, payload: result });
        } else {
            yield put({ type: types.GET_INVESTMENT_DETAILS_FAILURE, message: result?.message });
        }
    } catch (e) {
        console.log(e)
        const msg = extractError(e, "Failed to fetch investment details");
        yield put({ type: types.GET_INVESTMENT_DETAILS_FAILURE, message: msg });
        toast.error(msg);
    }
}

function* createInvestment(action) {
    try {
        const result = yield call(req.createInvestmentReq, action);
        if (result.success === true) {
            toast.success(result.message || "Investment created successfully");
            yield put({ type: types.CREATE_INVESTMENT_SUCCESS, payload: result.data });
            action?.data?.onSuccess?.();
        } else {
            const msg = result?.message || "Failed to create investment";
            yield put({ type: types.CREATE_INVESTMENT_FAILURE, message: msg });
            toast.error(msg);
        }
    } catch (e) {
        console.log(e)
        const msg = extractError(e, "Failed to create investment");
        yield put({ type: types.CREATE_INVESTMENT_FAILURE, message: msg });
        toast.error(msg);
    }
}

function* updateInvestment(action) {
    try {
        const result = yield call(req.updateInvestmentReq, action);
        if (result.success === true) {
            toast.success(result.message || "Investment updated successfully");
            yield put({ type: types.UPDATE_INVESTMENT_SUCCESS, payload: result.data });
            action?.data?.onSuccess?.();
        } else {
            const msg = result?.message || "Failed to update investment";
            yield put({ type: types.UPDATE_INVESTMENT_FAILURE, message: msg });
            toast.error(msg);
        }
    } catch (e) {
        console.log(e)
        const msg = extractError(e, "Failed to update investment");
        yield put({ type: types.UPDATE_INVESTMENT_FAILURE, message: msg });
        toast.error(msg);
    }
}

function* deleteInvestment(action) {
    try {
        const result = yield call(req.deleteInvestmentReq, action);
        if (result.success === true) {
            toast.success(result.message || "Investment deleted successfully");
            yield put({ type: types.DELETE_INVESTMENT_SUCCESS, payload: result.data });
            action?.data?.onSuccess?.();
        } else {
            const msg = result?.message || "Failed to delete investment";
            yield put({ type: types.DELETE_INVESTMENT_FAILURE, message: msg });
            toast.error(msg);
        }
    } catch (e) {
        console.log(e)
        const msg = extractError(e, "Failed to delete investment");
        yield put({ type: types.DELETE_INVESTMENT_FAILURE, message: msg });
        toast.error(msg);
    }
}

function* matureInvestment(action) {
    try {
        const result = yield call(req.matureInvestmentReq, action);
        if (result.success === true) {
            toast.success(result.message || "Investment matured successfully");
            yield put({ type: types.MATURE_INVESTMENT_SUCCESS, payload: result.data });
            action?.data?.onSuccess?.();
        } else {
            const msg = result?.message || "Failed to mature investment";
            yield put({ type: types.MATURE_INVESTMENT_FAILURE, message: msg });
            toast.error(msg);
        }
    } catch (e) {
        console.log(e)
        const msg = extractError(e, "Failed to mature investment");
        yield put({ type: types.MATURE_INVESTMENT_FAILURE, message: msg });
        toast.error(msg);
    }
}

function* preMatureInvestment(action) {
    try {
        const result = yield call(req.preMatureInvestmentReq, action);
        if (result.success === true) {
            toast.success(result.message || "Investment pre-matured successfully");
            yield put({ type: types.PRE_MATURE_INVESTMENT_SUCCESS, payload: result.data });
            action?.data?.onSuccess?.();
        } else {
            const msg = result?.message || "Failed to pre-mature investment";
            yield put({ type: types.PRE_MATURE_INVESTMENT_FAILURE, message: msg });
            toast.error(msg);
        }
    } catch (e) {
        console.log(e)
        const msg = extractError(e, "Failed to pre-mature investment");
        yield put({ type: types.PRE_MATURE_INVESTMENT_FAILURE, message: msg });
        toast.error(msg);
    }
}

function* renewInvestment(action) {
    try {
        const result = yield call(req.renewInvestmentReq, action);
        if (result.success === true) {
            toast.success(result.message || "Investment renewed successfully");
            yield put({ type: types.RENEW_INVESTMENT_SUCCESS, payload: result.data });
            action?.data?.onSuccess?.();
        } else {
            const msg = result?.message || "Failed to renew investment";
            yield put({ type: types.RENEW_INVESTMENT_FAILURE, message: msg });
            toast.error(msg);
        }
    } catch (e) {
        console.log(e)
        const msg = extractError(e, "Failed to renew investment");
        yield put({ type: types.RENEW_INVESTMENT_FAILURE, message: msg });
        toast.error(msg);
    }
}

function* calculateInvestmentPreview(action) {
    try {
        const result = yield call(req.calculateInvestmentPreviewReq, action);
        if (result.success === true) {
            yield put({ type: types.CALCULATE_INVESTMENT_PREVIEW_SUCCESS, payload: result.data });
        } else {
            yield put({ type: types.CALCULATE_INVESTMENT_PREVIEW_FAILURE, message: result?.message });
        }
    } catch (e) {
        console.log(e)
        // Silent for preview — no toast, just clear the preview
        yield put({ type: types.CALCULATE_INVESTMENT_PREVIEW_FAILURE, message: extractError(e, 'Preview failed') });
    }
}

export default function* InvestmentSaga() {
    yield takeLatest(types.GET_INVESTMENTS, getInvestments);
    yield takeLatest(types.GET_INVESTMENT_DETAILS, getInvestmentDetails);
    yield takeLatest(types.CREATE_INVESTMENT, createInvestment);
    yield takeLatest(types.UPDATE_INVESTMENT, updateInvestment);
    yield takeLatest(types.DELETE_INVESTMENT, deleteInvestment);
    yield takeLatest(types.CALCULATE_INVESTMENT_PREVIEW, calculateInvestmentPreview);
    yield takeLatest(types.MATURE_INVESTMENT, matureInvestment);
    yield takeLatest(types.PRE_MATURE_INVESTMENT, preMatureInvestment);
    yield takeLatest(types.RENEW_INVESTMENT, renewInvestment);
}
